module.exports = "//static.hsappstatic.net/LoginUI/static-1.8414/img/unsupported-browser.svg"